import "nprogress/nprogress.css";

import NProgress from "nprogress";

import router, { goLogin } from "@/router";
import { useMenuStore } from "@/store/modules/menu";
import { useUserStoreHook } from "@/store/modules/user";

NProgress.configure({ showSpinner: false }); // 进度条

// 白名单路由，支持字符串全匹配和正则判断
const loginRegExp = /^\/login(\/.*)?$/;
const whiteList = [loginRegExp, "/loading"];
const allRouter = router.getRoutes();

function isLoginPath(path: string) {
  return loginRegExp.test(path);
}

function isCurLoginPath(path: string) {
  const tenantCode = localStorage.getItem("tenantCode");
  return path.indexOf(`/login/${tenantCode}`) > -1;
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  // 不需要登录态的页面直接访问
  const isInWhiteList = whiteList.some((path) => {
    if (typeof path === "string") {
      return path === to.path;
    } else if (path instanceof RegExp) {
      return path.test(to.path);
    }
  });

  if (isInWhiteList) {
    next();
    NProgress.done();
    return;
  }

  const userStore = useUserStoreHook();
  const menuStore = useMenuStore();
  const hasToken = userStore.tokens && userStore.tokens.accessToken;
  if (hasToken) {
    // 是登录页
    if (isLoginPath(to.path)) {
      // 已登录: 是当前租户->跳转首页，不是当前租户 -> 正常进登录
      isCurLoginPath(to.path) ? next({ path: "/" }) : next();
      NProgress.done();
    } else {
      const hasUserInfo = !!Object.keys(userStore.userInfo).length;
      if (hasUserInfo) {
        // 未匹配到任何路由，跳转404
        if (to.matched.length === 0) {
          from.name ? next({ name: from.name }) : next("/404");
        } else {
          next();
        }
      } else {
        try {
          await userStore.getInfo();
          await menuStore.initMenu();
          // 菜单权限判断
          const menuFlat = menuStore.menuFlat;
          const target = menuFlat.some((item) => {
            return item.path === to.path;
          });
          const hasPermission = target || to.meta?.noMenu;
          const hasRouter = allRouter.some((item) => item.path === to.path);

          if (!hasPermission && hasRouter) {
            next("/403");
          }
          hasPermission ? next({ ...to, replace: true }) : next("/");
        } catch (error) {
          // 移除 token 并跳转登录页
          await userStore.resetAll();
          goLogin();
          NProgress.done();
        }
      }
    }
  } else {
    goLogin();
    NProgress.done();
  }
});

router.afterEach(() => {
  NProgress.done();
});
